import { Box } from '@mui/material'

import { ViewFundActivity } from './view-fund-activity'
import { ViewFundDocuments } from './view-fund-documents'

export function ViewFundSummary() {
  return (
    <Box>
      <ViewFundActivity />
      <ViewFundDocuments />
    </Box>
  )
}
